import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../../services/uiTranslations/reactBindings/L10nText';
import { NavButton } from '../../navButton/NavButton';

import styles from './LobbyControlPlain.module.css';

interface LobbyControlPlainProps {
  onClick?: () => void;
  branding: boolean;
}

export const LobbyControlPlain: FC<LobbyControlPlainProps> = ({ onClick, branding }): ReactElement => (
  <NavButton data-testid="lobby-button" onClick={onClick}>
    <>
      {branding ? (
        <div className={styles.brand}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 20.1c-1.8 0-3.7.3-5.4.9A17 17 0 0 0 2 9.2c1.7.4 5.4 2.5 7 7.6 0-3.4.8-11.2 3-14.8 2.2 3.6 3 11.4 3 14.8 1.6-5.1 5.3-7.2 7-7.6A17 17 0 0 0 17.4 21c-1.7-.6-3.6-.9-5.4-.9Z" />
          </svg>
        </div>
      ) : null}
      <L10nText tk="LOBBY" />
    </>
  </NavButton>
);
